// extracted by mini-css-extract-plugin
export default {"item":"FriendListItem_item__LJ5SH","name":"FriendListItem_name__KqblD","true":"FriendListItem_true__JKYYN","false":"FriendListItem_false__rFKJu"};